import { getToken } from 'firebase/messaging';
import { messaging } from '../integrations/Firebase';
import { deleteToken } from 'firebase/messaging';
export const requestForToken = async () => {
  try {
    if (process.env.REACT_APP_ENV === 'Development') return false;
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const firebaseVapIDKey = process.env.REACT_APP_GOOGLE_CLOUD_FIREBASE_VAPID_KEY;
      // Wait for the service worker to be ready
      const serviceWorkerRegistration = await navigator.serviceWorker.ready;
      const token = await getToken(messaging, {
        vapidKey: firebaseVapIDKey, // Replace this with your actual VAPID key from Firebase Console
        serviceWorkerRegistration: serviceWorkerRegistration,
      });

      if (token) {
        console.log('✅ FCM Token retrieved:');
        return token;

      } else {
        console.warn('⚠️ No registration token available. Request permission to generate one.');
        return false;
      }
    }
    else {
      console.warn('❌ Notification permission not granted');
    }
  } catch (error) {
    if (error.code === 'messaging/permission-blocked') {
      console.error('🚫 Notification permissions are blocked.');
    } else {
      console.error('❌ Error retrieving FCM token:', error);
    }
  }
};

export const logoutUserFirebaseMessaging = async () => {
  try {
    // OPTIONAL: Delete FCM token
    const tokenDeleted = await deleteToken(messaging);
    if (tokenDeleted) {
      console.log('🗑️ FCM Token deleted successfully.');
    } else {
      console.warn('⚠️ Unable to delete FCM token.');
    }
    return;
  } catch (error) {
    console.error('❌ Error during logout:', error);
  }
};